import { defineComponent as n, computed as o, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as r, createCommentVNode as h, normalizeStyle as v } from "vue";
const _ = ["viewBox"], f = /* @__PURE__ */ e("mask", { id: "c8edfb0b-5da2-44a3-82d0-2acd52653193" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#c8edfb0b-5da2-44a3-82d0-2acd52653193)" }, u = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M0 345h512v167H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M194.8 239.3h-49.4a22.3 22.3 0 0 1 21.6-16.7v-33.4c-30.7 0-55.7 25-55.7 55.7v27.8h83.5a5.6 5.6 0 0 1 5.5 5.6v11H89v33.5h144.7v-44.5a39 39 0 0 0-39-39zm83.5 50v-100h-33.4v133.5h55.6v-33.4zm111.3 0v-100h-33.4v100H345V256h-33.3v66.8h100.1v-33.4z"
}, null, -1), z = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ n({
  __name: "iq",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), d = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      f,
      e("g", m, [
        t.flagName ? (i(), a("title", u, r(t.flagName), 1)) : h("", !0),
        p,
        k,
        g,
        x
      ]),
      e("g", z, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: v({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=iq-8d058d09.js.map
